import React, { useState } from 'react';
import styled from 'styled-components';
import { string, object } from 'prop-types';
import { length, split } from 'ramda';

import OrangeButton from '../OrangeButton';

const Button = styled(OrangeButton)`
  @media (max-width: 1000px) {
    display: block;
  }

  del {
    color: #fad0ac;
  }
`;

const ConditionalText = styled.span`
  @media (max-width: 1200px) {
    display: none;
  }
`;

const CheckoutButton = ({
  url, label, posData, onClick, ...props
}) => {
  const buttonTextParts = split(' ', label);
  const buttonLabel = posData.currentStep === 'highlights-subscription' ? 'Publicar' : 'Destacar';
  
  const [disabled, setDisabled] = useState(false);
  const handleClick = () => {
    if (disabled) return;
    setDisabled(true);
    onClick();
  };
  return (
    <Button {...props} onClick={handleClick} disabled={disabled}>
      {/* Had to do this validation because not all checkout button texts are normalized in hefesto */}
      {length(buttonTextParts) === 2 ? buttonTextParts[0] : buttonLabel}
      <ConditionalText>
        &nbsp; {length(buttonTextParts) === 2 ? buttonTextParts[1] : 'agora'}
      </ConditionalText>
    </Button>
  );
};

CheckoutButton.propTypes = {
  url: string,
  label: string.isRequired,
  posData: object.isRequired,
};

CheckoutButton.defaultProps = {
  url: '',
};

export default CheckoutButton;
